<template>
  <div class="landing">
    <HomePageRenderer
      :auth="false"
      :user="null"
      :testimonials="[]"
      :testimonials-loading="false"
      :preview="true"
      :selected-key="selectedKey"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import HomePageRenderer from '@/components/home/HomePageRenderer.vue';
import { useHomepageConfig } from '@/composables/useHomepageConfig';

const { setDraftSections } = useHomepageConfig();
const selectedKey = ref(null);

// Mirrors the existing "api_base_url" localStorage-override convention (see
// src/main.js) rather than a .env scheme — no .env files exist in this repo.
const portalOrigin = localStorage.getItem('homepage_portal_origin') || 'https://portal.tarekmath.com';

function onMessage(event) {
  if (portalOrigin && event.origin !== portalOrigin) return;
  const msg = event.data;
  if (!msg || msg.source !== 'homepage-builder') return;
  if (msg.type === 'draft-update') {
    setDraftSections(msg.payload.sections);
  } else if (msg.type === 'select-section') {
    selectedKey.value = msg.payload.key;
  }
}

onMounted(() => {
  window.addEventListener('message', onMessage);
  window.parent?.postMessage({ source: 'homepage-builder', type: 'preview-ready', payload: {} }, portalOrigin || '*');
});

onBeforeUnmount(() => {
  window.removeEventListener('message', onMessage);
});
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.landing { font-family: 'Cairo', sans-serif; direction: rtl; overflow-x: hidden; }
</style>
